import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminTable from '../AdminTable';
import { MODELS } from '../../../constants/admin/settings';
import {
    fetchEventPartnerDependencies,
    fetchEventPartners,
    createEventPartner,
    sendEmailToEventPartners,
    deleteEventPartners,
    openEventPartner
} from '../../../actions/admin/models/event.partners';
import { fetchCategoryConfig } from '../../../actions/admin/models/event.clearance';
import {
    fetchCopyClearanceDependencies,
    copyClearance,
    updateVisibleCategories,
    fetchVisibleCategoriesDependencies,
    bulkUpdateVisibleCategories
} from '../../../actions/admin/models/event.partner.clearance';
import AdminModalForm from '../AdminModalForm';
import EventPartnerInputs from '../../../components/admin/lineup/EventPartnerInputs';
import { openModalForm, openModalFormWithData } from '../../../actions/admin/modal.forms';
import { UserContext } from '../../../Application';
import { hasPermissions, PERMISSIONS } from '../../../constants/authentication/permissions';
import { dataSelector, selectedSelector } from '../../../selectors/admin/tables';
import SendEmailInputs from '../../../components/admin/lineup/SendEmailInputs';
import { PER_PAGE_OPTION_2 } from '../../../constants/admin/tables';
import { formDataSelector } from '../../../selectors/admin/forms';
import CopyPartnerClearance from '../../../components/admin/lineup/CopyPartnerClearance';
import SetVisibleCategoriesInputs from '../../../components/admin/lineup/SetVisibleCategoriesInputs';
import BulkSetVisibleCategoriesInputs from '../../../components/admin/lineup/BulkSetVisibleCategoriesInputs';

class EventPartners extends Component {
    state = {
        modalModel: '',
        selectedPartner: null
    };

    componentDidMount() {
        if (this.props.eventId) {
            this.props.fetchCategoryConfig(this.props.eventId);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.eventId && this.props.eventId !== prevProps.eventId) {
            this.props.fetchCategoryConfig(this.props.eventId);
        }
    }

    _deleteEventPartners = () => this.props.deleteEventPartners(this.props.eventId);
    _openAddPartnerModal = () => {
        this.setState({ modalModel: MODELS.EVENT_PARTNER });
        this.props.openModalForm();
    };
    _openMailModal = () => {
        this.setState({ modalModel: MODELS.BULK_PARTNERS_EMAIL });
        this.props.openModalFormWithData(MODELS.BULK_PARTNERS_EMAIL, {
            text: '',
            subject: `[Clear'em] ${this.props.event.name} - Update`
        });
    };
    _openCopyModal = () => {
        this.setState({ modalModel: MODELS.COPY_PARTNER_CLEARANCE });
        this.props.openModalFormWithData(MODELS.COPY_PARTNER_CLEARANCE, { copyFields: {} });
    };
    _openBulkSetVisibleCategoriesModal = () => {
        const categories = this.props.categoryConfig?.categories || [];
        const selectedPartnerIds = this.props.selection;

        const commonVisibleCategoryIds = categories
            .filter((cat) => {
                if (cat.visibleByDefault) {
                    return false;
                }
                const visibleByPartners = cat.visibleByPartners || [];
                return selectedPartnerIds.every((partnerId) => visibleByPartners.includes(partnerId));
            })
            .map((cat) => cat.id);

        this.setState({ modalModel: MODELS.BULK_SET_VISIBLE_CATEGORIES });
        this.props.openModalFormWithData(MODELS.BULK_SET_VISIBLE_CATEGORIES, {
            categoryIds: commonVisibleCategoryIds
        });
    };
    _openVisibleCategoriesModal = (partner) => {
        const categories = this.props.categoryConfig?.categories || [];
        const visibleCategoryIds = categories
            .filter(
                (cat) => !cat.visibleByDefault && cat.visibleByPartners && cat.visibleByPartners.includes(partner.id)
            )
            .map((cat) => cat.id);

        this.setState({
            modalModel: MODELS.SET_VISIBLE_CATEGORIES,
            selectedPartner: partner
        });
        this.props.openModalFormWithData(MODELS.SET_VISIBLE_CATEGORIES, {
            categoryIds: visibleCategoryIds
        });
    };
    _getVisibleCategories = (_, partner) => {
        const categories = this.props.categoryConfig?.categories || [];
        const visibleCategories = categories
            .filter(
                (cat) => cat.visibleByDefault || (cat.visibleByPartners && cat.visibleByPartners.includes(partner.id))
            )
            .map((cat) => cat.label);

        return visibleCategories.length > 0 ? visibleCategories.join(', ') : '—';
    };
    render() {
        const canSendEmail = this.props.selection.length;
        return (
            <UserContext.Consumer>
                {(user) => (
                    <React.Fragment>
                        <AdminTable
                            openItem={this._openVisibleCategoriesModal}
                            selectionActions={['COPY FROM', 'SEND EMAIL', 'SET VISIBLE CATEGORIES']}
                            selectionFunctions={[
                                this._openCopyModal,
                                this._openMailModal,
                                this._openBulkSetVisibleCategoriesModal
                            ]}
                            fetchDataFunction={this.props.fetchEventPartners}
                            subContextId={this.props.eventId}
                            model={MODELS.EVENT_PARTNER}
                            buttonAction={this._openAddPartnerModal}
                            pagination={true}
                            deleteAction={this._deleteEventPartners}
                            forceInitialPages={PER_PAGE_OPTION_2}
                            transformFunctions={{ visibleCategories: this._getVisibleCategories }}
                        />
                        {this.state.modalModel === MODELS.COPY_PARTNER_CLEARANCE ? (
                            <AdminModalForm
                                title="Copy From"
                                fetchDependencies={this.props.fetchCopyClearanceDependencies}
                                modelId={this.props.eventId}
                                fields={CopyPartnerClearance}
                                staticData={{
                                    eventName: this.props.event.name,
                                    for: this.props.selection,
                                    categoryConfig: this.props.categoryConfig
                                }}
                                model={MODELS.COPY_PARTNER_CLEARANCE}
                                createAction={(data) =>
                                    this.props.copyClearance(data, this.props.eventId, this.props.categoryConfig)
                                }
                                confirmLabel="COPY"
                            />
                        ) : null}
                        {this.state.modalModel === MODELS.BULK_PARTNERS_EMAIL ? (
                            <AdminModalForm
                                title={`Send Email to ${canSendEmail} Media Partners`}
                                modelId={this.props.eventId}
                                fields={SendEmailInputs}
                                forceClose={!canSendEmail}
                                model={MODELS.BULK_PARTNERS_EMAIL}
                                createAction={this.props.sendEmailToEventPartners}
                                confirmLabel={'Send'}
                            />
                        ) : null}
                        {this.state.modalModel === MODELS.SET_VISIBLE_CATEGORIES ? (
                            <AdminModalForm
                                title="Set Visible Categories"
                                modelId={this.props.eventId}
                                fields={SetVisibleCategoriesInputs}
                                fetchDependencies={this.props.fetchVisibleCategoriesDependencies}
                                staticData={{
                                    partner: this.state.selectedPartner
                                }}
                                model={MODELS.SET_VISIBLE_CATEGORIES}
                                createAction={(data) =>
                                    this.props.updateVisibleCategories(
                                        data,
                                        this.props.eventId,
                                        this.state.selectedPartner.id,
                                        this.props.categoryConfig
                                    )
                                }
                                confirmLabel={'Save'}
                            />
                        ) : null}
                        {this.state.modalModel === MODELS.BULK_SET_VISIBLE_CATEGORIES ? (
                            <AdminModalForm
                                title={`Set Visible Categories for ${this.props.selection.length} Partner${
                                    this.props.selection.length === 1 ? '' : 's'
                                }`}
                                modelId={this.props.eventId}
                                fields={BulkSetVisibleCategoriesInputs}
                                fetchDependencies={this.props.fetchVisibleCategoriesDependencies}
                                staticData={{
                                    selectedPartners: this.props.eventPartners.filter((p) =>
                                        this.props.selection.includes(p.id)
                                    )
                                }}
                                model={MODELS.BULK_SET_VISIBLE_CATEGORIES}
                                createAction={(data) =>
                                    this.props.bulkUpdateVisibleCategories(
                                        data,
                                        this.props.eventId,
                                        this.props.selection,
                                        this.props.categoryConfig
                                    )
                                }
                                confirmLabel={'Save'}
                            />
                        ) : null}
                        {this.state.modalModel === MODELS.EVENT_PARTNER ? (
                            <AdminModalForm
                                staticData={this.props.eventPartners}
                                title="Add Partners to Event"
                                modelId={this.props.eventId}
                                fields={EventPartnerInputs}
                                model={MODELS.EVENT_PARTNER}
                                fetchDependencies={this.props.fetchEventPartnerDependencies}
                                createAction={this.props.createEventPartner}
                            />
                        ) : null}
                    </React.Fragment>
                )}
            </UserContext.Consumer>
        );
    }
}

const mapStateToProps = (state) => ({
    eventPartners: dataSelector(state),
    event: formDataSelector(state, { model: MODELS.EVENT }),
    selection: selectedSelector(state),
    categoryConfig: formDataSelector(state, { model: MODELS.EVENT_CATEGORY_CONFIG })
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchEventPartners,
            openModalForm,
            openModalFormWithData,
            fetchEventPartnerDependencies,
            createEventPartner,
            sendEmailToEventPartners,
            openEventPartner,
            deleteEventPartners,
            fetchCopyClearanceDependencies,
            copyClearance,
            fetchCategoryConfig,
            updateVisibleCategories,
            fetchVisibleCategoriesDependencies,
            bulkUpdateVisibleCategories
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(EventPartners);
